import { Resource } from 'i18next';

const resources: Resource = {};

if (typeof __MFE_TRANSLATIONS__ !== 'undefined' && __MFE_TRANSLATIONS__) {
    // Microfrontend build: ship only the built locale, with no cross-language fallback.
    // `__MFE_TRANSLATIONS__` and `__LANG__` are inlined as literals by webpack's
    // DefinePlugin, so the non-matching `if` branches below (and their `require`d JSON)
    // are dead-code-eliminated per per-language build.
    if (__LANG__ === 'de') resources['de-de'] = { translation: require('./de-DE.json') };
    if (__LANG__ === 'en') resources['en-us'] = { translation: require('./en-US.json') };
    if (__LANG__ === 'es') resources['es-us'] = { translation: require('./es-US.json') };
    if (__LANG__ === 'fr') resources['fr-fr'] = { translation: require('./fr-FR.json') };
    if (__LANG__ === 'it') resources['it-it'] = { translation: require('./it-IT.json') };
    if (__LANG__ === 'ja') resources['ja-jp'] = { translation: require('./ja-JP.json') };
    if (__LANG__ === 'nl') resources['nl-nl'] = { translation: require('./nl-NL.json') };
    if (__LANG__ === 'pt') resources['pt-br'] = { translation: require('./pt-BR.json') };
} else {
    // Client, server, and test builds: keep every supported locale.
    resources['de-de'] = { translation: require('./de-DE.json') };
    resources['en-us'] = { translation: require('./en-US.json') };
    resources['es-us'] = { translation: require('./es-US.json') };
    resources['fr-fr'] = { translation: require('./fr-FR.json') };
    resources['it-it'] = { translation: require('./it-IT.json') };
    resources['ja-jp'] = { translation: require('./ja-JP.json') };
    resources['nl-nl'] = { translation: require('./nl-NL.json') };
    resources['pt-br'] = { translation: require('./pt-BR.json') };
}

export default resources;
